import React from 'react';

import { GridHelper } from 'components/Grids/GridHelper';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import WorkflowStageFilter from 'components/ReactTable/Filters/WorkflowStageFilter';
import DateRangeFilter from 'components/ReactTable/Filters/DateRangeFilter';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import ValidationResultCell from 'components/ReactTable/CellRenderers/ValidationResultCell';
import Chapter3Status from 'common/Customers/Chapter3Status';
import Chapter4Status from 'common/Customers/Chapter4Status';
import CRSClassificationStatus from 'common/Customers/CRSClassificationStatus';
import CARFClassificationStatus from 'common/Customers/CARFClassificationStatus';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const validFormColumnDefs = (permissions, isPiiProtectionEnabled, piiValidationCodes) => [
  {
    Header: 'Customer Id',
    accessor: 'customer',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<CustomerLinkCell dataKey="customerDbId" data={ original } permissions={ permissions } />);
    },
    className: 'col-10p'
  },
  {
    Header: 'Form Type',
    accessor: 'formTypeDescription',
    Filter: MultiSelectFilter
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStatus',
    Filter: WorkflowStageFilter,
    Cell: (cellInfo) => {
      const { row: { original: { workflowStatus } } } = cellInfo;
      return workflowStatus || 'N/A';
    }
  },
  {
    Header: 'Account',
    accessor: 'account',
    Cell: (cellInfo) => {
      const { row: { original } } = cellInfo;
      return (<AccountLinkCell dataKey="accountId" data={ original } permissions={ permissions } />);
    },
    className: 'col-10p'
  },
  {
    Header: 'Warnings / Instructions',
    id: 'warnings',
    Cell: (cellInfo) => {
      const { row: { original: { validationData, formType } } } = cellInfo;
      return (<ValidationResultCell
        dataKey="warnings"
        data={ validationData }
        className="red-flags-and-recs-list"
        isPiiProtectionEnabled={ isPiiProtectionEnabled }
        piiValidationCodes={ piiValidationCodes }
        formType={ formType }
      />);
    },
    disableFilters: true,
    className: 'col-15p warnings-list'
  },
  {
    Header: 'Ch. 3 Status',
    accessor: 'chapter3Status',
    Filter: MultiSelectFilter,
    options: Chapter3Status.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'Ch. 4 Status',
    accessor: 'chapter4Status',
    Filter: MultiSelectFilter,
    options: Chapter4Status.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'CRS Status',
    accessor: 'crsStatus',
    Filter: MultiSelectFilter,
    options: CRSClassificationStatus.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'CARF Status',
    accessor: 'carfStatus',
    Filter: MultiSelectFilter,
    options: CARFClassificationStatus.map(item => ({ value: item.name, title: item.description })).sort((a, b) => (a.title > b.title ? 1 : -1)),
    className: 'col-10p'
  },
  {
    Header: 'Sign Date',
    accessor: 'signDate',
    disableFilters: true
  },
  {
    Header: 'Expiration Date',
    accessor: 'validUntil',
    Cell: (cellInfo) => {
      let tmp;
      const expiryReason = cellInfo.row.original.expiryReasonDescription !== null ? `(${ cellInfo.row.original.expiryReasonDescription })` : '';
      if (cellInfo.row.original.validUntil === 1000) {
        tmp = `Evergreen ${ expiryReason }`;
      } else {
        tmp = `${ GridHelper.dateFormatter(cellInfo.row.original.validUntil, 'MMM DD, YYYY') } ${ expiryReason }`;
      }
      return tmp;
    },
    Filter: DateRangeFilter
  },
  {
    Header: 'Treaty Country',
    accessor: 'treatyCountry',
    className: 'col-7p5'
  },
];

export default validFormColumnDefs;
